import { useFormContext } from "react-hook-form";

const PersonnalNumberField = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <label
        htmlFor="personnal-number"
        className="block text-sm font-medium leading-5 text-gray-900"
      >
        Personalnummer
      </label>
      <input
        type="text"
        id="personnal-number"
        {...register("personnalNumber")}
        className="mt-1 focus:ring-orange-500 focus:border-orange-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
      />

      {errors.personnalNumber && (
        <span className="text-sm font-light text-red-500">
          Personalnummer fehlt
        </span>
      )}
    </>
  );
};

export default PersonnalNumberField;
